import { useState, useEffect, useRef } from 'react';
import { Check } from 'lucide-react';
import { Button } from './ui/button';

const features = [
  'Flexible MOQ options',
  'Custom branding & designs',
  'Export-ready packaging',
  'Worldwide shipping',
];

export const ManufacturingSection = ({ onRequestQuote }) => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="wholesale"
      ref={sectionRef}
      className="py-14 md:py-20 bg-[#F8F6F2] leaf-pattern relative border-t border-gray-200 px-5 md:px-0"
      data-testid="manufacturing-section"
    >
      <div className="max-w-7xl mx-auto px-0 sm:px-6 lg:px-8">
        <div
          className={`text-center max-w-3xl mx-auto transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <h2 className="text-2xl font-semibold tracking-tight text-[#2B2B2B] mb-8 md:text-3xl lg:text-4xl">
            Your Global Manufacturing Partner
          </h2>

          {/* Features Grid - 2x2 */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8 max-w-xl mx-auto text-left">
            {features.map((feature, index) => (
              <div
                key={feature}
                className={`flex items-center gap-3 transition-all duration-500 ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
                }`}
                style={{ transitionDelay: `${(index + 1) * 100}ms` }}
              >
                <div className="w-5 h-5 rounded-full bg-[#2F4F3E] flex items-center justify-center flex-shrink-0">
                  <Check className="w-3 h-3 text-white" />
                </div>
                <span className="text-[#2B2B2B] text-sm leading-relaxed">
                  {feature}
                </span>
              </div>
            ))}
          </div>

          {/* CTA Button */}
          <div
            className={`transition-all duration-700 delay-500 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
            }`}
          >
            <Button
              onClick={onRequestQuote}
              className="w-full md:w-auto bg-green-700 hover:bg-green-800 text-white rounded-xl py-3 shadow-md px-8 text-sm font-medium transition-all duration-200"
              data-testid="manufacturing-quote-btn"
            >
              Request Wholesale Quote
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
